<template>
  <svg class="edit-icon" xmlns="http://www.w3.org/2000/svg" width="12.329" height="12.329" viewBox="0 0 12.329 12.329">
    <path data-name="edit-icon" d="M3,12.9v2.082a.339.339,0,0,0,.342.342H5.424a.321.321,0,0,0,.24-.1l7.478-7.472L10.574,5.184,3.1,12.655A.336.336,0,0,0,3,12.9ZM15.129,5.766a.682.682,0,0,0,0-.966l-1.6-1.6a.682.682,0,0,0-.966,0L11.307,4.451l2.568,2.568,1.253-1.253Z" transform="translate(-3 -2.997)" fill="#fff"/>
  </svg>
</template>

<script>
  export default {
    name: 'EditIcon'
  }
</script>

<style>
  .edit-icon {
    margin-right: 10px;
  }
</style>